export enum TemplateTypeCode {
  CreateScript = 'template.type.document.create-script',
  TextMessage = 'template.type.conversation.text-message',
  ClinicalReferral = 'template.type.document.clinical-referral',
  HomeBasedCareReferral = 'template.type.document.home-based-care-referral',
  MotivationMedicalDevice = 'template.type.document.motivation-medical-device',
}
